import { VFC } from 'react';
import { Box } from '@mui/material';
import { IVoteBoxProps } from '../VotesList/types';
import { VoteResult } from '../../config/variables';
import {
  StyledList,
  StyledItem,
  StyledResult,
  StyledDetailLink,
} from './VoteBoxContent.style';

export const VoteBoxContent: VFC<IVoteBoxProps> = ({
  subject,
  date,
  result,
  meetingCode,
  id,
}) => (
  <Box display={'flex'} flexDirection={'column'}>
    <Box fontWeight={600} marginBottom={'10px'}>
      {subject}
    </Box>
    <StyledList>
      <StyledItem>{date}</StyledItem>
      <StyledItem>
        <Box marginRight={'4px'} fontWeight={600}>
          Schůze:
        </Box>
        <div>{meetingCode}</div>
      </StyledItem>
      <StyledResult result={result}>
        {result === VoteResult.Accepted ? 'Přijato' : 'Nepřijato'}
      </StyledResult>
      <StyledItem>
        <StyledDetailLink>Detail hlasování</StyledDetailLink>
      </StyledItem>
    </StyledList>
  </Box>
);
